import React, { useState, useEffect, useMemo } from 'react';
import { Table, Button, Modal, Form, Card, Alert, Container, FormControl, OverlayTrigger, Tooltip, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserEdit, faTrash, faKey, faUserPlus, faCircleInfo, faBan, faWarning, faEye, faList, faCircleCheck, faEyeSlash, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUsers, addUser, deleteUser, updateUser } from '../redux/slice/UsersSlice';
import '../assets/UserManagement.css';
import LoadingComponent from '../components/LoadingComponent';
import Notifications from '../components/Notifications';
import {
  fetchUserDescriptions
} from "../redux/slice/userDescriptionsSlice";
const ADMIN_DESCRIPTION_NAME = 'admin';

const UserManagement = () => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [showModalPass, setShowModalPass] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertVariant, setAlertVariant] = useState('info');
  const [userCount, setUserCount] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [formErrors, setFormErrors] = useState({});
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState({ action: '', user: null });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [daysFilter, setDaysFilter] = useState('');
  const [descriptionFilter, setDescriptionFilter] = useState('');
  const [formData, setFormData] = useState({
    block_user: false,
    user_payed: true,
    first_name: '',
    last_name: '',
    username: '',
    email: '',
    phone_number: '',
    second_phone_number: '',
    description_id: '',
    password: '',
  });
  const { users, status, error } = useSelector(state => state.users);

  const { items: descriptions, status: descStatus } = useSelector(
    (state) => state.userDescriptions
  );

  useEffect(() => {
    dispatch(fetchUserDescriptions());
  }, [dispatch]);

  useEffect(() => {
    if (!users || users.length === 0) {

      const fetchData = async () => {
        // console.log('εκτελεστηκε')
        try {
          await dispatch(fetchUsers());
        } catch (error) {
          //console.error('Error fetching data:', error);
        }
      };

      fetchData();
    } else {
      // console.log('δεν εκτελεστηκε')
    }
  }, [dispatch, users]);


  const sortedUsers = useMemo(() => {
    return [...users].sort((a, b) => {
      return a.first_name.localeCompare(b.first_name, 'el', { sensitivity: 'base' });
    });
  }, [users]);  // ταξινόμηση μόνο όταν αλλάζει το users


  const greekToEnglishMap = {
    'α': 'a', 'ά': 'a',
    'β': 'b',
    'γ': 'g',
    'δ': 'd',
    'ε': 'e', 'έ': 'e',
    'ζ': 'z',
    'η': 'i', 'ή': 'i',
    'θ': 'th',
    'ι': 'i', 'ί': 'i', 'ϊ': 'i', 'ΐ': 'i',
    'κ': 'k',
    'λ': 'l',
    'μ': 'm',
    'ν': 'n',
    'ξ': 'x',
    'ο': 'o', 'ό': 'o',
    'π': 'p',
    'ρ': 'r',
    'σ': 's', 'ς': 's',
    'τ': 't',
    'υ': 'i', 'ύ': 'i', 'ϋ': 'i', 'ΰ': 'i',
    'φ': 'f',
    'χ': 'ch',
    'ψ': 'ps',
    'ω': 'o', 'ώ': 'o',
    'ει': 'i', 'οί': 'i',
  };


  const englishToGreekMap = {
    'a': 'α',
    'b': 'β',
    'g': 'γ',
    'd': 'δ',
    'e': 'ε',
    'z': 'ζ',
    'i': ['ι', 'η', 'υ', 'ει', 'οι'],
    'th': 'θ',
    'k': 'κ',
    'l': 'λ',
    'm': 'μ',
    'n': 'ν',
    'x': 'ξ',
    'o': 'ο',
    'p': 'π',
    'r': 'ρ',
    's': ['σ', 'ς'],
    't': 'τ',
    'y': 'υ',
    'f': 'φ',
    'ch': 'χ',
    'ps': 'ψ'
  };


  const handleClose = () => {
    setShowModal(false);
    setShowModalPass(false);
    setEditUser(null);
    setFormData({
      block_user: false,
      user_payed: false,
      first_name: '',
      last_name: '',
      username: '',
      email: '',
      phone_number: '',
      second_phone_number: '',
      description_id: '',
      password: '',
    });
  };

  const handleShow = (user) => {
    setEditUser(user);
    setShowModal(true);
    setFormData({
      block_user: user?.block_user || false,
      user_payed: user?.user_payed || false,
      first_name: user?.first_name || '',
      last_name: user?.last_name || '',
      username: user?.username || '',
      email: user?.email || '',
      phone_number: user?.phone_number || '',
      second_phone_number: user?.second_phone_number || '',
      description_id: user?.description_id || '',
      password: '',
    });
  };
  const handleShowPassword = (user) => {
    setEditUser(user);
    setShowModalPass(true);
    setFormData({
      block_user: user?.block_user || false,
      user_payed: user?.user_payed || false,
      first_name: user?.first_name || '',
      last_name: user?.last_name || '',
      username: user?.username || '',
      email: user?.email || '',
      phone_number: user?.phone_number || '',
      second_phone_number: user?.second_phone_number || '',
      description_id: user?.description_id || '',
      password: '',
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    handleBlur(name, value)
  };

  const handleShowConfirm = (action, user, e) => {
    setShowModal(false);
    setShowModalPass(false);
    setConfirmAction({ action, user });
    setShowConfirmModal(true);
  };

  const handleConfirmClose = () => {
    setShowConfirmModal(false);
  };

  const handleConfirmAction = async () => {
    const { action, user } = confirmAction;
    try {
      if (action === 'delete') {
        await handleDelete(user.id);
      } else if (action === 'edit' || action === 'add' || action === 'password') {
        handleSave(action);
      }
      setShowConfirmModal(false);
    } catch (err) {
      setAlertMessage('Η ενέργεια απέτυχε.');
      setAlertVariant('danger');
      setShowToast(true);
    }
  };

  const handleDelete = async (id) => {
    try {
      await dispatch(deleteUser(id)).unwrap();
      setAlertMessage('Ο χρήστης διαγράφηκε με επιτυχία.');
      setAlertVariant('success');
      setShowToast(true);
    } catch (err) {
      setAlertMessage(err);
      setAlertVariant('danger');
      setShowToast(true);
    }
  };

  const handleSave = async (action) => {
    // e.preventDefault();
    if (!formData.first_name || !formData.last_name || !formData.username || !formData.email || !formData.phone_number || !formData.second_phone_number) {
      setAlertMessage("Σφάλμα: Όλα τα πεδία είναι υποχρεωτικά.");
      setAlertVariant('danger');
      setShowToast(true);
      return;
    }

    if (!formData.description_id) {
      setAlertMessage("Επιλέξτε ιδιότητα χρήστη.");
      setAlertVariant("danger");
      setShowToast(true);
      return;
    }

    if (
      formData.description_id &&
      !descriptions.some((d) => d.id === Number(formData.description_id))
    ) {
      setAlertMessage("Η ιδιότητα χρήστη δεν είναι έγκυρη.");
      setAlertVariant("danger");
      setShowToast(true);
      return;
    }

    setIsSubmitting(true);

    let newUser = {
      ...formData,
      description_id: formData.description_id ? Number(formData.description_id) : null,
    };

    // Έλεγχος για υπάρχον χρήστη με το ίδιο username
    const duplicateUsername = sortedUsers.find(
      (user) =>
        user?.username === newUser?.username && (!editUser || user?.id !== editUser?.id)
    );

    // Έλεγχος για υπάρχον χρήστη με το ίδιο email
    const duplicateEmail = sortedUsers.find(
      (user) =>
        user?.email === newUser?.email && (!editUser || user?.id !== editUser?.id)
    );

    if (duplicateEmail && duplicateUsername) {
      setAlertMessage(`Σφάλμα: Το username και το email χρησιμοποιείται ήδη.`);
      setAlertVariant('danger');
      setShowToast(true);
      return;
    }

    if (duplicateUsername) {
      setAlertMessage(`Σφάλμα: Το username χρησιμοποιείται ήδη.`);
      setAlertVariant('danger');
      setShowToast(true);
      return;
    }

    if (duplicateEmail) {
      setAlertMessage(`Σφάλμα: Το email χρησιμοποιείται ήδη.`);
      setAlertVariant('danger');
      setShowToast(true);
      return;
    }

    if (editUser && action === 'edit') {
      // Αν επεξεργαζόμαστε χρήστη, αφαιρούμε το password
      const { password, ...rest } = newUser;
      newUser = rest;
    }

    try {
      if (editUser && action === 'edit') {
        // Ενημέρωση υπάρχοντος χρήστη
        await dispatch(updateUser({ userId: editUser?.id, userData: newUser })).unwrap();
        setAlertMessage(`Τα στοιχεία του χρήστη ${newUser?.username} ενημερώθηκαν με επιτυχία.`);
      } else if (editUser && action === 'password') {
        // Προσθήκη νέου χρήστη
        await dispatch(updateUser({ userId: editUser?.id, userData: newUser })).unwrap();
        setAlertMessage(`Τα κωδικός πρόσβασης του χρήστη ${newUser?.username} ενημερώθηκε με επιτυχία.`);
      } else {
        // Προσθήκη νέου χρήστη
        await dispatch(addUser(newUser)).unwrap();
        setAlertMessage(`Ο χρήστης ${newUser?.username} προστέθηκε επιτυχώς.`);
      }

      setAlertVariant('success');
      setShowToast(true);
    } catch (err) {
      setAlertMessage(`Σφάλμα: Η ${editUser ? 'ενημέρωση στοιχείων ' : 'προσθήκη χρήστη'} απέτυχε.`);
      setAlertVariant('danger');
      setShowToast(true);
    }

    handleClose();
    setIsSubmitting(false);
  };

  const handleBlur = (fieldName, value) => {
    let error = '';
    switch (fieldName) {
      case 'first_name':
      case 'last_name':
        if (value.length < 3) {
          error = 'Το πεδίο πρέπει να περιέχει τουλάχιστον 3 χαρακτήρες.';
        }
        break;
      case 'email':
        const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(value)) {
          error = 'Το email δεν είναι έγκυρο.';
        }
        break;
      case 'phone_number':
        if (!/^\d{10}$/.test(value)) {
          error = 'Ο αριθμός τηλεφώνου πρέπει να είναι 10 αριθμούς.';
        }
        break;
      case 'second_phone_number':
        if (!/^\d{10}$/.test(value)) {
          error = 'Ο αριθμός τηλεφώνου πρέπει να είναι 10 αριθμούς.';
        }
        break;
      case 'password':
        if (value.length < 6) {
          error = 'Ο κωδικός πρέπει να περιέχει τουλάχιστον 6 χαρακτήρες.';
        }
        break;
      default:
        break;
    }
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: error,
    }));
  };

  const handleToggleBlock = () => {
    // Αλλάζουμε μόνο το lock property, χωρίς να πειράξουμε τα υπόλοιπα
    setFormData((prevState) => ({
      ...prevState,  // Κρατάμε όλα τα υπόλοιπα properties ίδια
      block_user: !prevState.block_user
    }));
  };

  const handleTogglePayed = () => {
    setFormData((prevState) => {
      // Αν ο χρήστης δεν έχει πληρώσει και τώρα θα πληρώσει (δηλαδή από false γίνεται true)
      if (!prevState.user_payed) {
        return {
          ...prevState,
          user_payed: true,   // Ορίζουμε το user_payed σε true
          block_user: false   // Ξεμπλοκάρουμε τον χρήστη όταν πληρώσει
        };
      } else {
        // Αν είναι ήδη πληρωμένο ή αν αλλάζει σε unpaid, δεν επηρεάζουμε το block_user
        return {
          ...prevState,
          user_payed: false,  // Αναποδογυρίζουμε την τιμή του user_payed
          block_user: true   // Ξεμπλοκάρουμε τον χρήστη όταν πληρώσει
        };
      }
    });
  };

  const isFormValid = () => {
    // Δεν λαμβάνουμε υπόψη το password στο validation αν επεξεργαζόμαστε χρήστη (editUser === true) η αλλαγή κωδικού γίνεται ξεχωριστά
    const filteredErrors = editUser
      ? Object.keys(formErrors).filter((key) => key !== 'password').map((key) => formErrors[key])
      : Object.values(formErrors);
    return (
      filteredErrors.every((error) => error === '')
    );
  };

  const handleLoadMore = () => {
    setUserCount(prevCount => prevCount + 50);
  };

  const handleShowAllDetails = () => {
    setShowDetails(!showDetails);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const convertText = (text, map) => {
    return text.split('').map(char => map[char] || char).join('');
  };

  const filteredUsers = useMemo(() => {
    return sortedUsers.filter((user) => {
      // --- SEARCH ---
      const searchLower = searchTerm.toLowerCase();
      const searchGreek = convertText(searchLower, englishToGreekMap);
      const searchEnglish = convertText(searchLower, greekToEnglishMap);

      const matchesSearch =
        user?.first_name.toLowerCase().includes(searchLower) ||
        user?.last_name.toLowerCase().includes(searchLower) ||
        user?.first_name.toLowerCase().includes(searchGreek) ||
        user?.last_name.toLowerCase().includes(searchGreek) ||
        user?.first_name.toLowerCase().includes(searchEnglish) ||
        user?.last_name.toLowerCase().includes(searchEnglish) ||
        user?.phone_number.toString().includes(searchTerm);

      // --- DAYS FILTER ---
      const matchesDaysFilter = (() => {
        if (daysFilter === '') return true;
        if (daysFilter === '-1') return user.days_since_last_order === -1;
        if (daysFilter === '90') return user.days_since_last_order >= 90;
        if (daysFilter === '30') return user.days_since_last_order >= 30;
        if (daysFilter === '29')
          return user.days_since_last_order < 30 && user.days_since_last_order >= 0;
        return true;
      })();

      // --- DESCRIPTION FILTER ---
      const matchesDescription =
        !descriptionFilter ||
        Number(user.description_id) === Number(descriptionFilter);

      return matchesSearch && matchesDaysFilter && matchesDescription;
    });
  }, [
    sortedUsers,
    searchTerm,
    daysFilter,
    descriptionFilter,
  ]);


  const selectableDescriptions = useMemo(() => {
    return descriptions.filter(
      d => d.name?.toLowerCase() !== ADMIN_DESCRIPTION_NAME
    );
  }, [descriptions]);


  function getOrderStatusMessage(days) {
    if (days === -1) { // αν είναι -1 σημαινει πως δεν έχει παραγγείλει ποτέ
      return "Δεν έχει παραγγείλει ποτέ";
    } else if (days === 0) { // αν έχει παραγγείλει γαι τις επόμενες μέρες βαο
      return "Ενεργός";
    } else {
      return `Τελευταία παραγγελία ${days} ημέρες πριν`;
    }
  }
  // Render Loading, Error, or User List
  const renderContent = () => {
    if (status === 'loading') {
      return <LoadingComponent />;
    }

    if (status === 'error') {
      return <Alert variant="danger">Παρουσιάστηκε σφάλμα: {error}</Alert>;
    }

    if (filteredUsers.length === 0) {
      return <Alert variant="info">Δεν βρέθηκαν χρήστες.</Alert>;
    }

    if (!showDetails) {

      return (
        <>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Όνομα</th>
                <th>Email</th>
                <th className='hide-on-mobile'>Είδος Χρήστη</th>
                <th className='hide-on-mobile'>Ιδιότητα</th>
                <th className='hide-on-mobile'>Κατάσταση</th>
                <th>Ενέργειες</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.slice(0, userCount).map((user) => (
                <tr key={user?.id}>
                  <td>{user?.first_name} {user?.last_name}
                    {(user?.block_user && user?.user_payed) && <OverlayTrigger placement="bottom" overlay={<Tooltip className="in" id="tooltip-top">
                      {'Μπλοκαρισμένος άπο τον διαχειριστή.'}
                    </Tooltip>
                    }
                    >
                      <FontAwesomeIcon icon={faBan} size="sm" color="red" style={{ marginLeft: '5px' }} />
                    </OverlayTrigger>}
                    {(user?.block_user && !user?.user_payed) && <OverlayTrigger placement="bottom" overlay={<Tooltip className="in" id="tooltip-top">
                      {'Κλειδωμένος λογαριασμός λόγο μη καταβολής συνδρομής.'}
                    </Tooltip>
                    }
                    >
                      <FontAwesomeIcon icon={faWarning} size="sm" color="red" style={{ marginLeft: '5px' }} />
                    </OverlayTrigger>}
                    {(!user?.block_user && !user?.user_payed) && <OverlayTrigger placement="bottom" overlay={<Tooltip className="in" id="tooltip-top">
                      Δεν έχει πληρωμένη συνδρομή.
                    </Tooltip>
                    }
                    >
                      <FontAwesomeIcon icon={faWarning} size="sm" color="orange" style={{ marginLeft: '5px' }} />
                    </OverlayTrigger>}
                  </td>
                  <td>{user?.email}</td>
                  <td className='hide-on-mobile'>{user?.description_name || '-'}</td>
                  <td className='hide-on-mobile'>{user?.is_admin === true ? 'Admin' : 'Καταναλωτής'}</td>
                  <td className='hide-on-mobile'>{getOrderStatusMessage(user?.days_since_last_order)}</td>
                  <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                    <Button
                      className="btn-email"
                      onClick={() =>
                        window.open(
                          `https://email.elafa.gr/?create=1&_task=mail&_action=compose&to=${user.email}&_autologin=1&_token=2z09bywpjt4j1jgspc52h9wx816lv4ohok7gop7r59aq80iaz6`,
                          '_blank'
                        )
                      }
                    >
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip className="in" id="tooltip-top">
                            Αποστολή προσωπικού email.
                          </Tooltip>
                        }
                      >
                        <FontAwesomeIcon icon={faEnvelope} />
                      </OverlayTrigger>
                    </Button>
                    <Button className='btn-edits' onClick={() => handleShow(user)}>
                      <OverlayTrigger placement="bottom" overlay={<Tooltip className="in" id="tooltip-top">
                        Επεξεργασία στοιχειών του χρήστη.
                      </Tooltip>
                      }>
                        <FontAwesomeIcon icon={faUserEdit} />

                      </OverlayTrigger>

                    </Button>

                    <Button className='btn-delete' disabled={user?.is_admin} onClick={() => handleShowConfirm('delete', user)}>
                      <OverlayTrigger placement="bottom" overlay={<Tooltip className="in" id="tooltip-top">
                        Διαγραφή του χρήστη.
                      </Tooltip>
                      }>
                        <FontAwesomeIcon icon={faTrash} />

                      </OverlayTrigger>
                    </Button>

                    <Button className='btn-password' onClick={() => handleShowPassword(user)}>
                      <OverlayTrigger placement="bottom" overlay={<Tooltip className="in" id="tooltip-top">
                        Αλλαγή κωδικού πρόσβασης του χρήστη.
                      </Tooltip>
                      }>
                        <FontAwesomeIcon icon={faKey} />

                      </OverlayTrigger>
                    </Button>

                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          {userCount < filteredUsers.length && (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Button className="btn-load" onClick={handleLoadMore}>Περισσότερα</Button>
            </div>
          )}
        </>
      );
    }
    if (showDetails) {

      return (
        <>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Όνομα</th>
                <th>Email</th>
                <th>Όνομα Χρήστη</th>
                <th>Κατάσταση</th>
                <th>Αριθμός Τηλεφώνου</th>
                <th>Ιδιότητα</th>
                <th >Είδος Χρήστη</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.slice(0, userCount).map((user) => (
                <tr key={user?.id}>
                  <td>{user?.first_name} {user?.last_name}
                    {(user?.block_user && user?.user_payed) && <OverlayTrigger placement="bottom" overlay={<Tooltip className="in" id="tooltip-top">
                      {'Μπλοκαρισμένος άπο τον διαχειριστή.'}
                    </Tooltip>
                    }
                    >
                      <FontAwesomeIcon icon={faBan} size="sm" color="red" style={{ marginLeft: '5px' }} />
                    </OverlayTrigger>}
                    {(user?.block_user && !user?.user_payed) && <OverlayTrigger placement="bottom" overlay={<Tooltip className="in" id="tooltip-top">
                      {'Κλειδωμένος λογαριασμός λόγο μη καταβολής συνδρομής.'}
                    </Tooltip>
                    }
                    >
                      <FontAwesomeIcon icon={faWarning} size="sm" color="red" style={{ marginLeft: '5px' }} />
                    </OverlayTrigger>}
                    {(!user?.block_user && !user?.user_payed) && <OverlayTrigger placement="bottom" overlay={<Tooltip className="in" id="tooltip-top">
                      Δεν έχει πληρωμένη συνδρομή.
                    </Tooltip>
                    }
                    >
                      <FontAwesomeIcon icon={faWarning} size="sm" color="orange" style={{ marginLeft: '5px' }} />
                    </OverlayTrigger>}
                  </td>
                  <td>{user?.email}</td>
                  <td >{user?.username}</td>
                  <td >{getOrderStatusMessage(user?.days_since_last_order)}</td>
                  <td >{user?.phone_number}{user?.second_phone_number && `,${user?.second_phone_number}`}</td>
                  <td >{user?.description_name || '-'}</td>
                  <td >{user?.is_admin === true ? 'Admin' : 'Καταναλωτής'}</td>

                </tr>
              ))}
            </tbody>
          </Table>
          {userCount < filteredUsers.length && (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Button className="btn-load" onClick={handleLoadMore}>Περισσότερα</Button>
            </div>
          )}
        </>
      );
    }
  };

  return (
    <Container className="daily-container" style={{ minHeight: '100vh' }}>
      <Card className="p-0">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <div>
            <h3>Διαχείριση Χρηστών</h3>
            <h6 style={{ color: 'gray' }}><strong>Συνολικοί Χρήστες:</strong> {' '}{users.length}{' '}</h6>
          </div>
          <div>

            <Button className="btn-add" onClick={() => handleShow(null)}>
              <FontAwesomeIcon icon={faUserPlus} /> Προσθήκη
            </Button>
            <Button
              className="btn-email"
              onClick={() => window.open('https://email.elafa.gr?_autologin=1&_token=2z09bywpjt4j1jgspc52h9wx816lv4ohok7gop7r59aq80iaz6', '_blank')}
            >
              <FontAwesomeIcon icon={faEnvelope} /> Email
            </Button>

          </div>

        </Card.Header>
        <Card.Body>
          <Col xl='12' lg='12' md='12' sm='12'>
            <FormControl
              type="text"
              placeholder="Αναζήτηση με όνομα, επώνυμο ή αριθμό τηλεφώνου"
              className="mb-3"
              value={searchTerm}
              onChange={handleSearch}
              autoComplete='off'
              autoCorrect='off'
              spellCheck='false'
              style={{ minWidth: '250px' }}
            />
          </Col>

          <Row style={{ justifyContent: 'space-between' }}>
            <Col xl="5" lg="5" md="5" sm="12">
              <Form.Select
                className="mb-3"
                value={descriptionFilter}
                onChange={(e) => setDescriptionFilter(e.target.value)}
                style={{ minWidth: '250px', height: '50px' }}
              >
                <option value="">Όλες οι Ιδιότητες</option>

                {selectableDescriptions.map((desc) => (
                  <option key={desc.id} value={desc.id}>
                    {desc.name}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col xl='5' lg='5' md='5' xs='10'>
              <Form.Select
                className="mb-3"
                value={daysFilter}
                onChange={(e) => setDaysFilter(e.target.value)}
                style={{ minWidth: '250px', height: '50px' }}
              >
                <option value="">Όλοι οι Χρήστες</option>
                <option value="29">Πρόσφατη Παραγγελία</option>
                <option value="30">Τελευταία Παραγγελία πάνω από 1 μήνα</option>
                <option value="90">Τελευταία Παραγγελία πάνω από 3 μήνες</option>
                <option value="-1">Χωρίς Παραγγελία</option>
              </Form.Select>
            </Col>
            <Col xl='1' lg='1' md='1' xs='2'>
              <Button className="btn-show-details mb-3" style={{ height: '50px', width: '50px' }} onClick={handleShowAllDetails}>
                <OverlayTrigger placement="bottom" overlay={<Tooltip className="in" id="tooltip-top">
                  Προβολή όλων των λεπτομερειών χρήστη.
                </Tooltip>}>
                  <FontAwesomeIcon icon={faList} />
                </OverlayTrigger>
              </Button>
            </Col>


          </Row>

          {renderContent()}
        </Card.Body>
      </Card>

      {/* Modal for Add/Edit User */}
      <Modal show={showModalPass} onHide={handleClose}>
        <Form >
          <Modal.Header closeButton>
            <Modal.Title>{'Αλλαγή Κωδικού Πρόσβασης'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ display: 'flex' }}>

              <Form.Group className="mb-3 w-50" controlId="formFirstName">
                <Form.Label>Όνομα</Form.Label>
                <OverlayTrigger
                  placement="bottom"
                  show={!!formErrors['first_name']}
                  overlay={<Tooltip>{formErrors['first_name']}</Tooltip>}
                >
                  <Form.Control
                    disabled={true}
                    type="text"
                    name="first_name"
                    value={formData?.first_name}
                    onChange={handleChange}
                    onBlur={(e) => handleBlur('first_name', e.target.value)}
                    required
                  />
                </OverlayTrigger>
              </Form.Group>
              <Form.Group className="ms-2 mb-3 w-50" controlId="formLastName">
                <Form.Label>Επίθετο</Form.Label>
                <OverlayTrigger
                  placement="bottom"
                  show={!!formErrors['last_name']}
                  overlay={<Tooltip>{formErrors['last_name']}</Tooltip>}
                >
                  <Form.Control
                    disabled={true}
                    type="text"
                    name="last_name"
                    value={formData?.last_name}
                    onChange={handleChange}
                    onBlur={(e) => handleBlur('last_name', e.target.value)}
                    required
                  />
                </OverlayTrigger>
              </Form.Group>
            </div>
            <div style={{ display: 'flex' }}>

              <Form.Group className="mb-3 w-50" controlId="formUsername">
                <Form.Label>Username</Form.Label>
                <OverlayTrigger
                  placement="bottom"
                  show={!!formErrors['username']}
                  overlay={<Tooltip>{formErrors['username']}</Tooltip>}
                >
                  <Form.Control
                    disabled={true}
                    type="text"
                    name="username"
                    value={formData?.username}
                    onChange={handleChange}
                    onBlur={(e) => handleBlur('username', e.target.value)}
                    required
                  />
                </OverlayTrigger>
              </Form.Group>
              <Form.Group className="ms-2 mb-3 w-50" controlId="formEmail">
                <Form.Label>Email</Form.Label>
                <OverlayTrigger
                  placement="bottom"
                  show={!!formErrors['email']}
                  overlay={<Tooltip>{formErrors['email']}</Tooltip>}
                >
                  <Form.Control
                    disabled={true}
                    type="email"
                    name="email"
                    value={formData?.email}
                    onChange={handleChange}
                    onBlur={(e) => handleBlur('email', e.target.value)}
                    required
                  />
                </OverlayTrigger>
              </Form.Group>
            </div>
            <div style={{ display: 'flex' }}>

              <Form.Group className="mb-3 w-50" controlId="formPhoneNumber">
                <Form.Label>Τηλέφωνο</Form.Label>
                <OverlayTrigger
                  placement="bottom"
                  show={!!formErrors['phone_number']}
                  overlay={<Tooltip>{formErrors['phone_number']}</Tooltip>}
                >
                  <Form.Control
                    disabled={true}
                    type="text"
                    name="phone_number"
                    value={formData?.phone_number}
                    onChange={handleChange}
                    onBlur={(e) => handleBlur('phone_number', e.target.value)}
                    required
                  />
                </OverlayTrigger>
              </Form.Group>
              <Form.Group className="ms-2 mb-3 w-50" controlId="formDescription">
                <Form.Label>Ιδιότητα Χρήστη</Form.Label>
                <OverlayTrigger
                  placement="bottom"
                  show={!!formErrors['description_id']}
                  overlay={<Tooltip>{formErrors['description_id']}</Tooltip>}
                >
                  <Form.Select
                    disabled
                    name="description_id"
                    value={formData?.description_id || ''}
                    onChange={handleChange}
                  >
                    <option value="">Επιλέξτε</option>
                    {selectableDescriptions.map((desc) => (
                      <option key={desc.id} value={desc.id}>
                        {desc.name}
                      </option>
                    ))}

                  </Form.Select>
                </OverlayTrigger>
              </Form.Group>
            </div>

            <Form.Group className="mb-3" controlId="formPassword">
              <Form.Label>Κωδικός Πρόσβασης</Form.Label>
              <OverlayTrigger
                placement="bottom"
                show={!!formErrors['password']}
                overlay={<Tooltip>{formErrors['password']}</Tooltip>}
              >
                {/* <Form.Control
                  type="password"
                  name="password"
                  value={formData?.password}
                  onChange={handleChange}
                  onBlur={(e) => handleBlur('password', e.target.value)}
                  required
                /> */}
                <div className="d-flex align-items-center" style={{ position: 'relative' }}>
                  <Form.Control
                    type={showPassword ? 'text' : 'password'} // Εναλλαγή μεταξύ text και password
                    name="password"
                    value={formData?.password}
                    onChange={handleChange}
                    onBlur={(e) => handleBlur('password', e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="btn btn-link"
                    style={{
                      position: 'absolute',
                      right: '20px',
                      top: '5px',
                      background: 'transparent',
                      border: 'none',
                      cursor: 'pointer',
                    }}
                  >
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} color='black' />
                  </button>
                </div>
              </OverlayTrigger>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}><strong>Πίσω</strong></Button>
            <Button variant="primary" type="button" disabled={formData?.password.length < 6} onClick={(e) => handleShowConfirm('password', editUser, e)}>
              <strong>{'Άλλαγη κωδικού'}</strong>
            </Button>

          </Modal.Footer>
        </Form>
      </Modal>
      <Modal show={showModal} onHide={handleClose}>
        <Form >
          <Modal.Header closeButton>
            <Modal.Title>{editUser ? 'Επεξεργασία Χρήστη' : 'Προσθήκη Χρήστη'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            {<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>

              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', width: '50%', }}>
                <h6 className='text-offcanvas'>
                  Μπλοκάρισμα <OverlayTrigger placement="bottom" overlay={<Tooltip className="in" id="tooltip-top">
                    Ο χρήστης έχει περιορισμένη πρόσβαση μόνο για προβολή προηγούμενων παραγγελιών και επερχόμενων μενού.
                  </Tooltip>
                  }>
                    <FontAwesomeIcon icon={faCircleInfo} size="sm" color="gray" style={{ marginLeft: '5px' }} />
                  </OverlayTrigger>
                </h6>
                <Button
                  variant="light"
                  className={`custom-toggle-button ${formData?.block_user ? 'on' : 'off'}`}
                  onClick={handleToggleBlock}
                >
                  <div className={`slider ${formData?.block_user ? 'slide-on' : 'slide-off'}`}></div>
                  <div className={`label-${formData?.block_user ? 'on' : 'off'}`}>
                    {formData?.block_user ? 'Ναι' : 'Όχι'}
                  </div>
                </Button>
              </div>

              {/* {formData?.user_payed && `Πληρωμένη συνδρομή για το ${new Date().getFullYear()}`} */}
              {!formData?.user_payed && <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', width: '50%', }}>
                <h6 className='text-offcanvas'>
                  Πληρωμένη συνδρομή <OverlayTrigger placement="bottom" overlay={<Tooltip className="in" id="tooltip-top">
                    Ο χρήστης θα έχει περιορισμένη πρόσβαση αυτόματα στις 01/02/{new Date().getFullYear()} .
                  </Tooltip>
                  }>
                    <FontAwesomeIcon icon={faCircleInfo} size="sm" color="gray" style={{ marginLeft: '5px' }} />
                  </OverlayTrigger>
                </h6>
                <Button
                  variant="light"
                  className={`custom-toggle-button ${formData?.user_payed ? 'on' : 'off'}`}
                  onClick={handleTogglePayed}
                >
                  <div className={`slider ${formData?.user_payed ? 'slide-on' : 'slide-off'}`}></div>
                  <div className={`label-${formData?.user_payed ? 'on' : 'off'}`}>
                    {formData?.user_payed ? 'Ναι' : 'Όχι'}
                  </div>
                </Button>
              </div>}
              {formData?.user_payed && <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', width: '50%', }}>
                <h6 className='text-offcanvas'>
                  Πληρωμένη συνδρομή <OverlayTrigger placement="bottom" overlay={<Tooltip className="in" id="tooltip-top">
                    Πληρωμένη συνδρομή για το {new Date().getFullYear()}
                  </Tooltip>
                  }>
                    <FontAwesomeIcon icon={faCircleInfo} size="sm" color="gray" style={{ marginLeft: '5px' }} />
                  </OverlayTrigger>
                </h6>
                <FontAwesomeIcon icon={faCircleCheck} size="2x" color="green" style={{ marginLeft: '5px' }} />
                {/* <Button
                  variant="light"
                  className={`custom-toggle-button ${formData?.user_payed ? 'on' : 'off'}`}
                  onClick={handleTogglePayed}
                >
                  <div className={`slider ${formData?.user_payed ? 'slide-on' : 'slide-off'}`}></div>
                  <div className={`label-${formData?.user_payed ? 'on' : 'off'}`}>
                    {formData?.user_payed ? 'Ναι' : 'Όχι'}
                  </div>
                </Button> */}
              </div>}
            </div>}

            <Form.Group className="mb-3" controlId="formFirstName">
              <Form.Label>Όνομα</Form.Label>
              <OverlayTrigger
                placement="bottom"
                show={!!formErrors['first_name']}
                overlay={<Tooltip>{formErrors['first_name']}</Tooltip>}
              >
                <Form.Control
                  type="text"
                  name="first_name"
                  value={formData?.first_name}
                  onChange={handleChange}
                  onBlur={(e) => handleBlur('first_name', e.target.value)}
                  required
                />
              </OverlayTrigger>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formLastName">
              <Form.Label>Επίθετο</Form.Label>
              <OverlayTrigger
                placement="bottom"
                show={!!formErrors['last_name']}
                overlay={<Tooltip>{formErrors['last_name']}</Tooltip>}
              >
                <Form.Control
                  type="text"
                  name="last_name"
                  value={formData?.last_name}
                  onChange={handleChange}
                  onBlur={(e) => handleBlur('last_name', e.target.value)}
                  required
                />
              </OverlayTrigger>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formUsername">
              <Form.Label>Username (Χρήση για είσοδο)</Form.Label>
              <OverlayTrigger
                placement="bottom"
                show={!!formErrors['username']}
                overlay={<Tooltip>{formErrors['username']}</Tooltip>}
              >
                <Form.Control
                  type="text"
                  name="username"
                  value={formData?.username}
                  onChange={handleChange}
                  onBlur={(e) => handleBlur('username', e.target.value)}
                  required
                />
              </OverlayTrigger>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <OverlayTrigger
                placement="bottom"
                show={!!formErrors['email']}
                overlay={<Tooltip>{formErrors['email']}</Tooltip>}
              >
                <Form.Control
                  type="email"
                  name="email"
                  value={formData?.email}
                  onChange={handleChange}
                  onBlur={(e) => handleBlur('email', e.target.value)}
                  required
                />
              </OverlayTrigger>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formPhoneNumber">
              <Form.Label>Τηλέφωνο Επικοινωνίας</Form.Label>
              <OverlayTrigger
                placement="bottom"
                show={!!formErrors['phone_number']}
                overlay={<Tooltip>{formErrors['phone_number']}</Tooltip>}
              >
                <Form.Control
                  type="text"
                  name="phone_number"
                  value={formData?.phone_number}
                  onChange={handleChange}
                  onBlur={(e) => handleBlur('phone_number', e.target.value)}
                  required
                />
              </OverlayTrigger>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formSecondPhoneNumber">
              <Form.Label>Τηλέφωνο Επικοινωνίας (2)</Form.Label>
              <OverlayTrigger
                placement="bottom"
                show={!!formErrors['second_phone_number']}
                overlay={<Tooltip>{formErrors['second_phone_number']}</Tooltip>}
              >
                <Form.Control
                  type="text"
                  name="second_phone_number"
                  value={formData?.second_phone_number}
                  onChange={handleChange}
                  onBlur={(e) => handleBlur('second_phone_number', e.target.value)}
                  required
                />
              </OverlayTrigger>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formDescription">
              <Form.Label>Ιδιότητα</Form.Label>
              <OverlayTrigger
                placement="bottom"
                show={!!formErrors['description_id']}
                overlay={<Tooltip>{formErrors['description_id']}</Tooltip>}
              >
                <Form.Select
                  name="description_id"
                  value={formData?.description_id || ''}
                  onChange={handleChange}
                  required
                >
                  <option value="">Επιλέξτε</option>
                  {selectableDescriptions.map((desc) => (
                    <option key={desc.id} value={desc.id}>
                      {desc.name}
                    </option>
                  ))}

                </Form.Select>

              </OverlayTrigger>
            </Form.Group>

            {!editUser && (
              <Form.Group className="mb-3" controlId="formPassword">
                <Form.Label>Κωδικός Πρόσβασης</Form.Label>
                <OverlayTrigger
                  placement="bottom"
                  show={!!formErrors['password']}
                  overlay={<Tooltip>{formErrors['password']}</Tooltip>}
                >
                  {/* <Form.Control
                    type="password"
                    name="password"
                    value={formData?.password}
                    onChange={handleChange}
                    onBlur={(e) => handleBlur('password', e.target.value)}
                    required
                  /> */}
                  <div className="d-flex align-items-center" style={{ position: 'relative' }}>
                    <Form.Control
                      type={showPassword ? 'text' : 'password'} // Εναλλαγή μεταξύ text και password
                      name="password"
                      value={formData?.password}
                      onChange={handleChange}
                      onBlur={(e) => handleBlur('password', e.target.value)}
                      required
                    />
                    <button
                      type="button"
                      onClick={togglePasswordVisibility}
                      className="btn btn-link"
                      style={{
                        position: 'absolute',
                        right: '20px',
                        top: '5px',
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                    >
                      <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} color='black' />
                    </button>
                  </div>
                </OverlayTrigger>
              </Form.Group>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}><strong>Πίσω</strong></Button>
            <Button variant="primary" type="button" disabled={!isFormValid() || isSubmitting} onClick={(e) => handleShowConfirm(editUser ? 'edit' : 'add', editUser, e)}>
              <strong>{editUser ? 'Αποθήκευση Άλλαγων' : 'Προσθήκη Χρήστη'}</strong>
            </Button>

          </Modal.Footer>
        </Form>
      </Modal>

      <Modal show={showConfirmModal} onHide={handleConfirmClose}>
        <Modal.Header closeButton>
          <Modal.Title>Επιβεβαίωση
            {confirmAction.action === 'delete' && ' Διαγραφής'}
            {confirmAction.action === 'edit' && ' Επεξεργασίας'}
            {confirmAction.action === 'password' && ' Αλλαγή Κωδικού Πρόσβασης'}
            {confirmAction.action === 'add' && ' Προσθήκης Χρήστη'} </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {confirmAction.action === 'delete' && (
            <p>Είστε σίγουροι ότι θέλετε να διαγράψετε τον χρήστη {confirmAction.user?.first_name} {confirmAction.user?.last_name};</p>
          )}
          {confirmAction.action === 'password' && (
            <p>Είστε σίγουροι ότι θέλετε να αλλάξετε τον κωδικό πρόσβασης του χρήστη {confirmAction.user?.first_name} {confirmAction.user?.last_name};</p>
          )}
          {confirmAction.action === 'edit' && (
            <p>Είστε σίγουροι ότι θέλετε να επεξεργαστείτε τον χρήστη {confirmAction.user?.first_name} {confirmAction.user?.last_name};</p>
          )}
          {confirmAction.action === 'add' && (
            <p>Είστε σίγουροι ότι θέλετε να προσθέσετε νέο χρήστη;</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="modal-btn" onClick={handleConfirmClose}>
            <strong>Ακύρωση</strong>
          </Button>
          <Button variant="primary" className="modal-btn" onClick={handleConfirmAction}>
            <strong>Επιβεβαίωση</strong>
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Notification Toast */}
      <Notifications
        message={alertMessage}
        variant={alertVariant}
        show={showToast}
        onClose={() => setShowToast(false)}
      />
    </Container>
  );
};

export default UserManagement;
